var $4584808aa0b38739$exports = {};
$4584808aa0b38739$exports = {
    "replaceMessage": `\u{5E9}\u{5D7}\u{5E8}\u{5E8} \u{5D0}\u{5EA} \u{5D4}\u{5E7}\u{5D5}\u{5D1}\u{5E5} \u{5DC}\u{5D4}\u{5D7}\u{5DC}\u{5E4}\u{5D4}`
};


export {$4584808aa0b38739$exports as default};
//# sourceMappingURL=he-IL.mjs.map
